import { VFC } from 'react'
import { Link } from 'src/elements/Link'
import { _menuicon, orange, truewhite } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import { flexCenter } from 'src/styles/mixins'
import styled from 'styled-components'

type NavigationItemProps = {
  Icon: SvgrComponent
  label: string
  href: string
  isNew?: boolean
  unreadCount?: number
}
export const NavigationItem: VFC<NavigationItemProps> = ({
  Icon,
  label,
  href,
  isNew,
  unreadCount = 0,
}) => (
  <Item href={href}>
    <Icon />
    <p>{label}</p>
    {!unreadCount && isNew && <NewMark>New!</NewMark>}
    {unreadCount > 0 && (
      <UnreadCount>{unreadCount > 999 ? 999 : unreadCount}</UnreadCount>
    )}
  </Item>
)

const Item = styled(Link)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 42px;
  margin-right: 42px;
  svg {
    width: 24px;
    height: 24px;
    g,
    path {
      color: ${_menuicon};
      transition: all 0.2s ease-in-out;
    }
  }
  :hover {
    svg {
      g {
        stroke: ${orange};
      }
      path {
        stroke: none;
        fill: ${orange};
      }
    }
  }
  p {
    font-size: 11px;
    font-weight: ${fontWeightBold};
    white-space: nowrap;
  }
`

const NewMark = styled.p`
  position: absolute;
  top: 0;
  left: 72%;
  color: ${orange};
`

const UnreadCount = styled.p`
  position: absolute;
  top: -20%;
  left: 60%;
  height: 2em;
  width: 2em;
  overflow: hidden;
  background-color: ${orange};
  color: ${truewhite};
  border-radius: 50%;
  ${flexCenter};
`
